import { render, staticRenderFns } from "./Bibliography.vue?vue&type=template&id=d1f6583a&"
import script from "./Bibliography.vue?vue&type=script&lang=js&"
export * from "./Bibliography.vue?vue&type=script&lang=js&"
import style0 from "./Bibliography.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports